<template>
  <v-card class="mb-3">
    <v-toolbar dark dense color="primary">Mark calculator
      <v-spacer/>
      <v-btn x-small color="error box-shadow" @click="noShow">no show</v-btn>
    </v-toolbar>
    <v-simple-table dense class="box-shadow">
      <template v-slot:default>
        <thead style="background-color: #9190b5">
        <tr>
          <th class="text-left" v-for="(item, idx) in marking_criteria_items" :key="idx">{{ item.mark }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td v-for="(item, idx) in marking_criteria_items" :key="idx">{{ item.percent }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider/>

    <template v-for="(category, idx) in marks">
      <v-card-actions class="justify-space-between" :key="'v'+idx">
        {{ category.name }} <v-chip>{{ category.value }}</v-chip>
      </v-card-actions>
      <v-divider :key="'d'+idx"/>
      <v-card-text class="py-1" :key="idx">
        <v-select v-for="(sub_category, i) in category.children" :key="i" class="my-2"
                  dense outlined hide-details
                  :label="sub_category.name"
                  v-model="sub_category.value"
                  :items="marks_opts"
                  @input="calculateAvg"
                  clearable
        />
        <!--      <v-list-item >-->
        <!--        <v-list-item-content v-text="sub_category.name"/>-->

        <!--      </v-list-item>-->

      </v-card-text>
    </template>

    <v-divider/>
    <v-card-actions class="box-shadow justify-space-between success">
      <span>Final mark:</span> <span><v-chip>{{ final_mark }}</v-chip></span>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Array,
      default: Array
    },
    final_mark: {
      default: null,
    },
  },
  data: () => ({
    marks: [],
    marks_opts: [
      {text: 'A', value: '100'},
      {text: 'B', value: '80'},
      {text: 'C', value: '60', pass: 'pass'},
      {text: 'D', value: '40'},
      {text: 'E', value: '20'},
      {text: 'F', value: '0'},
    ],
    marking_criteria_items: [
      {mark: 'A', percent: '100'},
      {mark: 'B', percent: '80'},
      {mark: 'C', percent: '60', pass: 'pass'},
      {mark: 'D', percent: '40'},
      {mark: 'E', percent: '20'},
      {mark: 'F', percent: '0'},
      {mark: 'G', percent: 'N/A'},
    ],
  }),
  watch: {
    value: function (val) {
      this.marks = val ?? []
    }
  },
  mounted() {
    this.marks = this.value ?? []
  },
  methods: {
    calculateAvg() {
      let mapped = this.marks.map(item => {
        let avg = this._.sumBy(item.children, o => parseInt(o.value)) / item.children.length
        if(isNaN(avg)) {avg = 0}
        return {...item, value: avg}
      })
      this.$emit('input', mapped)

      let final_mark = this._.sumBy(mapped, o => parseInt(o.value)) / mapped.length
      this.$emit('finalMarkUpdated', final_mark)
    },
    noShow() {
      let mapped = this.marks.map(item => {
        return {...item, value: 0}
      })
      this.$emit('input', mapped)
      this.$emit('finalMarkUpdated', 'no show')
    }
  }
}
</script>
